<template>
  <div class="home-page">
    <!-- 头部导航栏 -->
    <!-- 第一块  公司名称 + 背景图 -->
    <main-company-name></main-company-name>
    <!-- 第二块  业务及解决方案 li -->
    <main-options></main-options>
    <!-- 第三块  系统开发的特征 + IT解决方案系统开发事业 -->
    <main-introduce></main-introduce>
    <!-- 第四块  分割块 -->
    <main-tip-msg></main-tip-msg>
    <!-- 资质页面 -->
    <certificationPage></certificationPage>
    <!-- 其他业务 -->
    <otherBusiness></otherBusiness>
    <!-- 第四块  关于我们介绍 -->
    <main-about-msg></main-about-msg>
  </div>
</template>

<script>
import mainCompanyName from '../components/companyName';
import mainOptions from '../components/options';
import mainIntroduce from '../components/introduce';
import mainTipMsg from '../components/tipMsg';
import certificationPage from '../components/certification';
import otherBusiness from '../components/other-business';
import mainAboutMsg from '../components/aboutMsg';

export default {
  components: {
    mainCompanyName,
    mainOptions,
    mainIntroduce,
    mainTipMsg,
    mainAboutMsg,
    certificationPage,
    otherBusiness
  },
}
</script>

<style scoped lang="scss">
.home-page {
  width: 100%;
  height: auto;
  background: $write;
}
</style>
  
